import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import swal from 'sweetalert';
import {addSuppliers, deleteSuppliers, updateSuppliers} from "../../../action";
import ErrorContainer from "../../../components/utils/ErrorContainer";

export function SupplierModal({ onClose, isEditMode, supplier }) {
    const dispatch = useDispatch();
    const [data, setData] = useState({
        name: supplier ? supplier.name : '',
    });

    useEffect(() => {
        if (isEditMode && supplier) {
            setData({
                name: supplier.name || '',
            });
        }
        return () => setData({ name: '' });
    }, [isEditMode, supplier]);

    const onChangeInput = (field) => (e) => setData({ ...data, [field]: e.target.value });

    const isValid = () => !!data.name;

    const onSubmit = async (e) => {
        e.preventDefault();
        const supplierData = { name: data.name };

        try {
            if (isEditMode) {
                await dispatch(updateSuppliers(supplier.id, supplierData));
            } else {
                await dispatch(addSuppliers(supplierData));
            }
            onClose();
        } catch (error) {
            console.log('Error', error);
        }
    };

    const onDelete = () => {
        swal({
            title: `Удаление поставщика`,
            text: `Вы действительно хотите удалить поставщика "${supplier.name}"?`,
            icon: "warning",
            dangerMode: true,
            buttons: ["Отмена", "Удалить"],
        }).then((willDelete) => {
            if (willDelete) {
                dispatch(deleteSuppliers(supplier.id)).then(() => {
                    swal("Поставщик успешно удалён!", {
                        icon: "success",
                    });
                    onClose();
                });
            }
        });
    };

    return (
        <>
            <div className="modal-backdrop fade show" style={{ zIndex: 1040 }}></div>
            <form onSubmit={onSubmit}>
                <div className="modal fade show" style={{ display: 'block', zIndex: 1050 }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    {isEditMode ? 'Редактирование поставщика' : 'Добавление поставщика'}
                                </h5>
                                <button onClick={onClose} type="button" className="close">
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="form-group">
                                    <label htmlFor="s-name" className="form-control-label">Наименование *</label>
                                    <input
                                        type="text"
                                        value={data.name}
                                        className="form-control"
                                        id="s-name"
                                        onChange={onChangeInput('name')}
                                    />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={onClose}>Отмена</button>
                                {isEditMode && (
                                    <button
                                        type="button"
                                        onClick={onDelete}
                                        className="btn btn-danger">
                                        Удалить
                                    </button>
                                )}
                                <button
                                    type="submit"
                                    disabled={!isValid()}
                                    className="btn btn-primary">
                                    {isEditMode ? 'Сохранить' : 'Добавить'}
                                </button>
                                <ErrorContainer field='supplier' hasCloseButton={true} style={{ margin: 25 }}/>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </>
    );
}
